import React from 'react';
import { Star } from 'lucide-react';

function UserItem({ user, navigate, onRemove }) {
  const goToProfile = () => navigate(`/profile/${user.user_id}`);

  return (
    <div className="tailwind flex items-center gap-4 px-4 py-3">
      <button
        type="button"
        aria-label={`Open ${user.username}'s profile`}
        onClick={goToProfile}
        className="relative h-12 w-12 shrink-0 overflow-hidden rounded-full"
      >
        <img
          src={user.profile_url || '/assets/images/default_profile.png'}
          alt={user.username}
          className="h-full w-full object-cover"
        />
      </button>

      <div className="min-w-0 flex-1">
        <p
          onClick={goToProfile}
          className="cursor-pointer truncate text-base font-medium text-gray-900 dark:text-gray-100"
          title={user.username}
        >
          {user.username}
        </p>
        {user.full_name && (
          <p className="mt-0.5 truncate text-xs text-gray-600 dark:text-gray-300" title={user.full_name}>
            {user.full_name}
          </p>
        )}
      </div>

      {(typeof user?.rating === 'number' && user.rating > 0) || onRemove ? (
        <div className="ml-auto flex items-center gap-2">
          {typeof user?.rating === 'number' && user.rating > 0 && (
            <div
              className="inline-flex items-center gap-1 rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700 dark:bg-neutral-800 dark:text-gray-200"
              aria-label={`Your rating for ${user.username} is ${user.rating} stars`}
              title={`Your rating for ${user.username}`}
            >
              <span>{user.rating}</span>
              <Star size={14} className="text-mainLightColor" fill="currentColor" />
            </div>
          )}

          {onRemove && (
            <button
              type="button"
              onClick={onRemove}
              className="inline-flex items-center rounded-md px-3 py-1.5 text-xs font-medium text-white focus:outline-none bg-likeColor"
            >
              Remove
            </button>
          )}
        </div>
      ) : null}
    </div>
  );
}

export default UserItem;
